import React from 'react';
import { Link } from 'react-router-dom';
import { Result, Button, Typography } from 'antd';
import { MailOutlined } from '@ant-design/icons';

const { Title, Paragraph } = Typography;

const VerifyEmailNoticePage = () => {
    return (
        <Result
            icon={<MailOutlined />}
            status="info"
            title={<Title level={3}>Bitte bestätigen Sie Ihre E-Mail-Adresse</Title>}
            subTitle={
                <Paragraph style={{ fontSize: '16px' }}>
                    Vielen Dank für Ihre Registrierung! Wir haben eine Bestätigungs-E-Mail an Ihre angegebene Adresse gesendet.
                    Bitte überprüfen Sie Ihr Postfach (auch den Spam-Ordner) und klicken Sie auf den Link in der E-Mail, um Ihr Konto zu aktivieren.
                </Paragraph>
            }
            extra={[
                <Paragraph key="info" style={{ marginTop: '20px' }}>
                    Nachdem Sie Ihre E-Mail bestätigt haben, können Sie sich anmelden.
                </Paragraph>,
                <Button type="primary" key="login">
                    <Link to="/login">Zur Login-Seite</Link>
                </Button>
            ]}
            style={{ padding: '50px', maxWidth: '600px', margin: '50px auto' }}
        />
    );
};

export default VerifyEmailNoticePage; 